// assets
import {
  Arrow,
  Book,
  CalendarEdit,
  CardTick1,
  Cards,
  CpuSetting,
  Fatrows,
  Message,
  MessageAdd1,
  Microphone2,
  NotificationFavorite,
  PresentionChart,
  Send2,
  Sms,
  Story,
  TimerStart
} from "iconsax-react";

// third-party
import { FormattedMessage } from "react-intl";

// icons
const icons = {
  widgets: Story,
  statistics: Story,
  data: Fatrows,
  chart: PresentionChart,
  message: Message,
  addMsg: MessageAdd1,
  sent: Send2,
  schedule: CalendarEdit,
  alert: NotificationFavorite,
  audio: Sms,
  contact: Book,
  credits: Cards,
  ussd: CardTick1,
  flow: Arrow,
  voice: Microphone2,
  history: TimerStart,
  settings: CpuSetting
};

// ==============================|| MENU ITEMS - WIDGETS ||============================== //

const services = {
  id: "services-menu",
  title: <FormattedMessage id=" " />,
  icon: icons.message,
  type: "group",
  children: [
    {
      id: "bulk-messaging",
      title: <FormattedMessage id="Send Message" />,
      type: "item",
      icon: icons.message,
      url: "/bulk-messaging/send-message"
    },
    {
      id: "schedule-a-message",
      title: (
        <>
          <FormattedMessage id="Schedule A Message" />
        </>
      ),
      type: "item",
      icon: icons.schedule,
      url: "/bulk-messaging/schedule-a-message/schedule"
    },
    {
      id: "message-history",
      title: <FormattedMessage id="Message History" />,
      type: "collapse",
      icon: icons.history,
      children: [
        {
          id: "sent_msgs",
          title: (
            <>
              <FormattedMessage id="Sent Messages" />
            </>
          ),
          type: "item",
          // icon: icons.sent,
          url: "/bulk-messaging/sent-messages"
        },

        {
          id: "scheduled_msgs",
          title: (
            <>
              <FormattedMessage id="Scheduled Messages" />
            </>
          ),
          type: "item",
          // icon: icons.schedule,
          url: "/bulk-messaging/scheduled-messages"
        }
      ]
    },

    // {
    //   id: "sms",
    //   title: <FormattedMessage id="SMS" />,
    //   type: "collapse",
    //   icon: icons.audio,
    //   children: [
    //     {
    //       id: "sender_id",
    //       title: (
    //         <>
    //           <FormattedMessage id="Sender IDs" />
    //         </>
    //       ),
    //       type: "item",
    //       url: "/bulk-messaging/senderids"
    //       //  breadcrumbs: false
    //     }
    //   ]
    // },
    // {
    //   id: "voice",
    //   title: <FormattedMessage id=" Voice" />,
    //   type: "collapse",
    //   // url: "/voice/start",
    //   icon: icons.voice,

    //   children: [
    //     // {
    //     //   id: "flow",
    //     //   title: (
    //     //     <>
    //     //       <FormattedMessage id="Voice Flows" />
    //     //     </>
    //     //   ),
    //     //   type: "item",
    //     //   url: "/voice/flow",
    //     //   breadcrumbs: false
    //     // },
    //     {
    //       id: "audio-library",
    //       title: (
    //         <>
    //           <FormattedMessage id="Audio Library" />
    //         </>
    //       ),
    //       type: "item",
    //       url: "/voice/audio-library",
    //       breadcrumbs: true
    //     }
    //     // {
    //     //   id: "old-audio-library",
    //     //   title: (
    //     //     <>
    //     //       <FormattedMessage id="Old Audio Library" />
    //     //     </>
    //     //   ),
    //     //   type: "item",
    //     //   url: "/voice/old-audio-library",
    //     //   breadcrumbs: false
    //     // },
    //     // {
    //     //   id: "ivr",
    //     //   title: (
    //     //     <>
    //     //       <FormattedMessage id="IVR" />
    //     //     </>
    //     //   ),
    //     //   type: "item",
    //     //   url: "/voice/ivr",
    //     //   breadcrumbs: false
    //     // }
    //   ]
    // },
    // {
    //   id: "campaigns",
    //   title: <FormattedMessage id="IVR Campaigns" />,
    //   type: "item",
    //   icon: icons.ussd,
    //   url: "/campaigns/voice"
    // },
    {
      id: "ussd",
      title: <FormattedMessage id="Subscriptions" />,
      type: "collapse",
      icon: icons.ussd,
      children: [
        {
          id: "callerid-subs",
          title: (
            <>
              <FormattedMessage id="Caller IDs" />
            </>
          ),
          type: "item",
          url: "/subscriptions/callerids",
          breadcrumbs: false
        },
        {
          id: "sub-callerids",
          title: (
            <>
              <FormattedMessage id="Caller ID Subscriptions" />
            </>
          ),
          type: "item",
          url: "/subscriptions/subscribed-callerids",
          breadcrumbs: false
        },
        {
          id: "shortcodes",
          title: (
            <>
              <FormattedMessage id="USSD Short Codes" />
            </>
          ),
          type: "item",
          url: "/ussd/shortcodes",
          breadcrumbs: false
        },

        {
          id: "subscriptions",
          title: (
            <>
              <FormattedMessage id="USSD Subscriptions" />
            </>
          ),
          type: "item",
          url: "/ussd/subscriptions",
          breadcrumbs: false
        }
      ]
    },
    {
      id: "campaigns",
      title: <FormattedMessage id="Campaigns" />,
      type: "collapse",
      icon: icons.flow,
      children: [
        {
          id: "IVR",
          title: (
            <>
              <FormattedMessage id="IVR" />
            </>
          ),
          type: "item",
          url: "/campaigns/voice",
          breadcrumbs: false
        },
        {
          id: "Responsive IVR",
          title: (
            <>
              <FormattedMessage id="IVR Responses" />
            </>
          ),
          type: "item",
          url: "/campaigns/responses",
          breadcrumbs: true
        }
      ]
    },
    {
      id: "address-book",
      title: <FormattedMessage id="Setup" />,
      type: "collapse",
      icon: icons.settings,
      children: [
        {
          id: "bulk_contact",
          title: (
            <>
              <FormattedMessage id="Import Bulk Contacts" />
            </>
          ),
          type: "item",
          url: "/address-book/bulk-imports"
        },
        {
          id: "manage_grps",
          title: (
            <>
              <FormattedMessage id="Manage Groups" />
            </>
          ),
          type: "item",
          url: "/address-book/groups"
        },
        {
          id: "sender_id",
          title: (
            <>
              <FormattedMessage id="Sender IDs" />
            </>
          ),
          type: "item",
          url: "/bulk-messaging/senderids"
          //  breadcrumbs: false
        },
        {
          id: "audio-library",
          title: (
            <>
              <FormattedMessage id="Audio Library" />
            </>
          ),
          type: "item",
          url: "/voice/audio-library",
          breadcrumbs: true
        },
        {
          id: "sms-templates",
          title: (
            <>
              <FormattedMessage id="SMS Templates" />
            </>
          ),
          type: "item",
          // icon: icons.audio,
          url: "/bulk-messaging/sms-templates",
          breadcrumbs: true
        }
      ]
    },
    {
      id: "credits",
      title: <FormattedMessage id="Credits" />,
      type: "collapse",
      icon: icons.credits,
      children: [
        {
          id: "balance",
          title: (
            <>
              <FormattedMessage id="Balance" />
            </>
          ),
          type: "item",
          url: "/credits/balance"
        },
        {
          id: "purchase_bundle",
          title: (
            <>
              <FormattedMessage id="Purchase Bundles" />
            </>
          ),
          type: "item",
          url: "/credits/bundles"
        },
        {
          id: "invoices",
          title: (
            <>
              <FormattedMessage id="Invoices" />
            </>
          ),
          type: "item",
          url: "/credits/invoices"
        }
      ]
    },
    {
      id: "profile",
      title: <FormattedMessage id="Profile" />,
      type: "item",
      url: "/user/profile",
      icon: icons.chart
    }
  ]
};

export default services;
